import type { ReactNode } from 'react';

const ICON = { info: 'ℹ️', warn: '⚠️', bad: '⛔', ok: '✓' } as const;
/** Alerta em linha (C-21). */
export default function Alert({ tone = 'info', icon, children }: { tone?: keyof typeof ICON; icon?: ReactNode; children: ReactNode }) {
  return (
    <div className={`alert ${tone}`} role={tone === 'bad' ? 'alert' : 'status'}>
      <span className="ic" aria-hidden>{icon ?? ICON[tone]}</span>
      <div>{children}</div>
    </div>
  );
}
